import { type FC } from 'react';
import { graphql, createFragmentContainer } from 'react-relay/legacy.js';

// Components
import { PdpSharedSocialSharePinterest } from '../shared/PdpSharedSocialShare/PdpSharedSocialSharePinterest.tsx';
import { PdpSharedSocialShareFacebook } from '../shared/PdpSharedSocialShare/PdpSharedSocialShareFacebook.tsx';
import { PdpSharedSocialShareEmail } from '../shared/PdpSharedSocialShare/PdpSharedSocialShareEmail.tsx';
import { PdpRespIconBubbleShare } from './PdpRespIconBubbleShare.tsx';

import { type PdpRespIconBubbles_viewer$data } from './__generated__/PdpRespIconBubbles_viewer.graphql.ts';
import { type PdpRespIconBubbles_item$data } from './__generated__/PdpRespIconBubbles_item.graphql.ts';
import { type PdpRespIconBubbles_user$data } from './__generated__/PdpRespIconBubbles_user.graphql.ts';
import { useServerVarsContext } from '../../global/ServerVarsContext/ServerVarsContext.tsx';

type Props = {
    viewer: PdpRespIconBubbles_viewer$data;
    item: PdpRespIconBubbles_item$data;
    user: PdpRespIconBubbles_user$data | null | undefined;
    skuId?: string | null;
};

const PdpTabletIconBubbles: FC<Props> = ({ item, skuId, user, viewer }) => (
    <>
        <PdpSharedSocialSharePinterest variant="iconBubble" item={item} />
        <PdpSharedSocialShareFacebook variant="iconBubble" item={item} />
        <PdpSharedSocialShareEmail
            variant="iconBubble"
            item={item}
            user={user}
            viewer={viewer}
            skuId={skuId}
        />
    </>
);

const PdpRespIconBubblesComponent: FC<Props> = props => {
    const { isDesktop } = useServerVarsContext();

    return isDesktop ? <PdpRespIconBubbleShare {...props} /> : <PdpTabletIconBubbles {...props} />;
};

export const PdpRespIconBubbles = createFragmentContainer(PdpRespIconBubblesComponent, {
    viewer: graphql`
        fragment PdpRespIconBubbles_viewer on Viewer {
            ...PdpSharedSocialShareEmail_viewer
            ...PdpRespIconBubbleShare_viewer
        }
    `,
    item: graphql`
        fragment PdpRespIconBubbles_item on Item {
            ...PdpSharedSocialSharePinterest_item
            ...PdpSharedSocialShareFacebook_item
            ...PdpSharedSocialShareEmail_item
            ...PdpRespIconBubbleShare_item
        }
    `,
    user: graphql`
        fragment PdpRespIconBubbles_user on User {
            ...PdpSharedSocialShareEmail_user
            ...PdpRespIconBubbleShare_user
        }
    `,
});
